<template>
  <div class="comp-user">
    <div class="card">
      <img @error="imgError" :src="data.Photo" :alt="data.Name" class="avatar" />
      <div class="right">
        <h3>{{ data.Name }}</h3>
        <p>{{ data.Title }}</p>
      </div>
    </div>
    <column-header2 :data="{ name: '个人简介' }"></column-header2>
    <div class="content">{{ data.Introduction }}</div>
    <column-header2 :data="{ name: '擅长领域' }"></column-header2>
    <div class="content">{{ data.Expertise }}</div>
  </div>
</template>

<script>
import ColumnHeader from "_c/ColumnHeader2";
export default {
  name: "user-detail",
  props: {
    data: {
      type: Object
    },
    target: {
      type: String,
      default: "_self"
    }
  },
  components: {
    [ColumnHeader.name]: ColumnHeader
  }
};
</script>

<style lang="scss" scoped>
.comp-user {
  .card {
    background: url(~assets/img/feature/watermarker.png) no-repeat
      $primary-color 95% top;
    background-size: 170px auto;
    border-radius: 8px;
    color: #fff;
    height: 102px;
    padding: 16px 40px;
    display: flex;
    align-items: center;
    .avatar {
      width: 104px;
      height: 104px;
      margin-right: 24px;
      border-radius: 52px;
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      h3 {
        font-size: 20px;
        font-weight: 500;
        padding-bottom: 8px;
      }
    }
  }
  .content {
    font-size: 14px;
    line-height: 28px;
    color: #666;
    padding-bottom: 20px;
  }
  ::v-deep .comp-column-header {
    padding-top: 24px;
  }
}
</style>
